export default "__VITE_ASSET__b7639efa__"